import React from "react"
import styles from "styles/hero.module.scss"
import Image from "components/image"

const companies = ["kredi", "onepipe", "openbanking", "lendsqr"]

const Hero = () => {
  return (
    <div className={styles.cover} id="cover">
      <div className="h-full flex items-center">
        <div className="w-full lg:w-7/12 pr-10 relative flex flex-col  items-center">
          <div className="h-20 md:h-40 w-full"></div>
          <div className="mx-auto w-10/12">
            <h1
              className="text-grey-100 font-bold text-4xl md:text-6xl shortFadeIn"
              style={{ lineHeight: "62px" }}
            >
              Banking System For Enterprises Across Africa and the World
            </h1>
            <h2
              className="text-grey-200 text-lg mt-3 md:w-8/12 shortFadeIn delay-300ms"
              style={{ lineHeight: "32px", letterSpacing: "0.01em" }}
            >
              Deploy our core banking system that sets you up for business in no
              time.
            </h2>
            <div className="mt-8 shortFadeIn delay-500ms">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://airtable.com/shrPDXj0LnwYEs31P"
                className={`text-white font-medium px-6 rounded-sm bg-green hover:bg-green-dark duration-500 ${styles.button}`}
              >
                Deploy a cluster
              </a>
            </div>
          </div>
          <div className=" w-10/12 inset-x-0 mx-auto bottom-0 mt-5 mt-24 mb-8 xl:mb-0 lg:mt-32">
            <p className="text-base text-grey-200">Trusted By</p>
            <div className="flex md:flex-no-wrap flex-wrap items-center md:mt-4">
              {companies.map(company => (
                <div
                  className="md:w-24 mr-3 md:mr-10 w-2/5 mt-8 md:mt-0"
                  key={company}
                >
                  <Image source={company} />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="hidden lg:block w-5/12 fadeIn">
          <Image source="heroImg" styles={{ height: "100%" }} />
        </div>
      </div>
    </div>
  )
}

export default Hero
